import React from 'react';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDContentContainer } from '@facet-wealth/design';
import { DetailContent } from './DetailContent';
import { IntroContent } from './IntroContent';

export const AccountOpeningV2TrustedContactIntroStepLayout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <WorkflowLayout appearance={'elevated'}>
      <FDContentContainer maxWidth="sm">
        {resource.isTruthy('hasTrustedContact') ? <DetailContent /> : <IntroContent />}
      </FDContentContainer>
    </WorkflowLayout>
  );
};
